export default __webpack_public_path__ + "static/media/WhyChooseTrovity.3d53c6cc.svg";